import React from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ROUTE_PATHS } from 'constants/index'
import SocialLinks from 'pages/Login/components/SocialLinks/index'
// import { BrandLogoIcon } from 'components/ui-kit/Icons/svg/index'
import { usePreLogin } from 'hooks/usePreLogin'
import { ClutchGameOn } from 'components/ui-kit/Icons/png/index'

const BannerSection = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const { handleRegister } = usePreLogin({ path: ROUTE_PATHS.CASINO })
  const { loginData } = useSelector((state) => state.auth)

  return (
    <section
      className='casino-banner'
    >
      <div className='home-banner-content'>
        {/* <BrandLogoIcon /> */}
        <img src={ClutchGameOn} className='img-fluid d-block mx-auto mb-2 game-on-logo-img' alt='clutch-game-on' />

        <h1>
          {t('bannerHeadOne')} <br /> {t('bannerHeadTwo')}
        </h1>
        <div className='banner-btn-wrap d-md-flex align-items-center'>
          <button
            type='button'
            className={`btn btn-secondary ${(location.pathname === ROUTE_PATHS.CASINO) ? 'd-none' : ''}`}
            onClick={handleRegister}
          >
            {loginData?.accessToken ? t('playNow') : t('registerNow')}
          </button>
          {!loginData?.accessToken && <SocialLinks isBannerSection />}
        </div>
      </div>
    </section>
  )
}

export default React.memo(BannerSection)
